export const styles = {
  storyImagesList: (width: number, height: number) => ({
    '& .swiper-slide': {
      '& > div': {
        maxWidth: `${width / 2}px`,
        maxHeight: `${height / 2}px`,
        width: '100%',
        margin: '0 auto',
        aspectRatio: `${width} / ${height}`,
        paddingBottom: 0,
        cursor: 'pointer',
        display: 'flex',
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '10px',
        height: '100%',
        '& > div': {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          padding: '0',
        },
      },
    },
  }),
  nav: {
    mt: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    gap: '16px',

    '& .suggestion-slider-control': {
      width: '24px',
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& button': {
      maxWidth: '208px',
    },
  },
  wrapper: (width: number, height: number) => ({
    '& > div:first-of-type': {
      maxWidth: `${width / 2}px`,
      maxHeight: `${height / 2}px`,
      width: '100%',
      margin: '0 auto',
      aspectRatio: `${width} / ${height}`,
      paddingBottom: 0,
    },
  }),
  regenerate: {
    height: '32px',
    padding: '8px 12px',
  },
};
